import type { Event, BookingCategory } from '@/features/events/types/types';

// removed formatEventDate function for now as it is not used
// Helper function to format event date
// export const formatEventDate = (event: Event) => {
//   if (event.event_type === 'REPEATED' && event.repeated_schedule) {
//     const startDate = new Date(event.repeated_schedule.start_date);
//     const dayNames = event.repeated_schedule.daily_times.map((time: { day_of_week: number }) => {
//       const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
//       return days[time.day_of_week];
//     });
//     return `${dayNames.join(', ')} ${startDate.toLocaleDateString('en-UK', { 
//       month: 'short', 
//       day: 'numeric' 
//     })}`;
//   }
//   // For single day events, date field is needed
//   return 'TBD';
// };

// Helper function to get event price
export const getEventPrice = (event: Event) => {
  if (event.booking_categories && event.booking_categories.length > 0) {

    const pricedCategory = event.booking_categories.find((cat: BookingCategory) => cat.default_price > 0);
    return pricedCategory ? pricedCategory.default_price : 0;
  }
  return 0;
};
